import { Routes, Route, NavLink } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Releases from "./pages/Releases";
import FeatureRequests from "./pages/FeatureRequests";
import BugReports from "./pages/BugReports";
import Versions from "./pages/Versions";

function App() {
  return (
    <div className="app">
      <nav className="sidebar">
        <div className="sidebar-header">
          <h1>POS DevPortal</h1>
          <span style={{ fontSize: "0.75rem", opacity: 0.7 }}>POS System Management</span>
        </div>
        <ul className="nav-links">
          <li>
            <NavLink to="/">Dashboard</NavLink>
          </li>
          <li>
            <NavLink to="/releases">Releases</NavLink>
          </li>
          <li>
            <NavLink to="/versions">Versions</NavLink>
          </li>
          <li>
            <NavLink to="/features">Feature Requests</NavLink>
          </li>
          <li>
            <NavLink to="/bugs">Bug Reports</NavLink>
          </li>
        </ul>
      </nav>
      <main className="content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/releases" element={<Releases />} />
          <Route path="/versions" element={<Versions />} />
          <Route path="/features" element={<FeatureRequests />} />
          <Route path="/bugs" element={<BugReports />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
